"use client";

import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AMomentOfReflection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}